export default "__VITE_ASSET__Bvn9EuQl__"